var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgArrowLong = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 24,
    viewBox: "0 0 85 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 20H0V20.5H0.5V20ZM84.8536 20.3536C85.0488 20.1583 85.0488 19.8417 84.8536 19.6464L81.6716 16.4645C81.4763 16.2692 81.1597 16.2692 80.9645 16.4645C80.7692 16.6597 80.7692 16.9763 80.9645 17.1716L83.7929 20L80.9645 22.8284C80.7692 23.0237 80.7692 23.3403 80.9645 23.5355C81.1597 23.7308 81.4763 23.7308 81.6716 23.5355L84.8536 20.3536ZM0.5 0H0V20H0.5H1V0H0.5ZM0.5 20V20.5H84.5V20V19.5H0.5V20Z",
    fill: "#404040"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowLong, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-long.09e2d396.svg";
export { ForwardRef as ReactComponent };